import Image from 'next/image';
import { type NetworkData, NETWORKS } from 'src/common/types/network';

import { SelectItem } from '@/design-system/components/ui';
import useGetChainInfo from '@/hooks/useGetChainInfo';

import { FormikSelect } from './FormikSelect';

interface FormikNetworkSelectProps {
  name?: string;
  label?: string;
  supportedChainIds?: number[];
  filterFn?: (network: NetworkData) => boolean;
}

export default function FormikNetworkSelect({
  name = 'chainId',
  label = 'Network',
  supportedChainIds,
  filterFn,
}: FormikNetworkSelectProps) {
  const { getChainIconUrl } = useGetChainInfo();

  const filteredNetworks = NETWORKS.filter((network) => {
    if (supportedChainIds) return supportedChainIds.includes(network.chainId);
    if (filterFn) return filterFn(network);
    return true;
  });

  return (
    <FormikSelect name={name} label={label} parseValue={(v) => Number(v)}>
      {filteredNetworks.map(({ chainId, name: networkName }) => {
        const splittedName = networkName.split(' ').join('-').toLowerCase();
        const svg = '/assets/svg/' + splittedName + '.svg';
        const chainIconUrl = getChainIconUrl(chainId) || svg;

        return (
          <SelectItem value={String(chainId)} key={chainId}>
            <div className="tw:flex tw:items-center tw:gap-2">
              <Image src={chainIconUrl} width={20} height={20} alt={networkName} />
              <span className="tw:capitalize">{networkName}</span>
            </div>
          </SelectItem>
        );
      })}
    </FormikSelect>
  );
}
